module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Ga-Ha-Ia-Gd.6e464194.png";